import React from 'react';
import { NCZICompositionItem } from '../../../../Interfaces/ncziTypes';
import EHROpenableEntry from '../EHROpenableEntry/EHROpenableEntry';
import EHROpenableEntrySection from '../EHROpenableEntry/EHROpenableEntrySection';

interface Props {
	item: NCZICompositionItem | undefined;
	patientIdentifier: string;
	onCloseDetail?: (needReload: boolean) => void;
}

const EHRCompositionItemAsList: React.FC<Props> = props => {
	const { item, patientIdentifier, onCloseDetail } = props;

	if (item?.entry) {
		return (
			<EHROpenableEntry
				item={item.entry}
				patientIdentifier={patientIdentifier}
				onCloseDetail={onCloseDetail}
			/>
		);
	}

	if (item?.section) {
		return (
			<EHROpenableEntrySection
				section={item.section}
				patientIdentifier={patientIdentifier}
				onCloseDetail={onCloseDetail}
			/>
		);
	}

	return <></>;
};

export default EHRCompositionItemAsList;
